import { Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'

import { Illustration } from '@/components/Illustration/Illustration'

export const LtqcSignVerifiedPage = observer(() => {
  const store = useContext(StoreContext)
  const { ltqcSignPage: trans } = store.TranslationsState.translations

  const location = window.location.href
  const url = new URL(location)
  const isError = url.searchParams.get('error')

  if (isError)
    return (
      <div className="page-container mobile-m-0 vertically-centered">
        <Illustration type="error" />
        <Header className="m-0-0-30">{trans.Error.header}</Header>

        <p className="generic__paragraph-centered m-0-0-30">{trans.Error.description}</p>
      </div>
    )

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <Illustration type="success" />
      <Header className="m-0-0-30">{trans.Verified.header}</Header>
      <p className="generic__paragraph-centered m-0-0-30">{trans.Verified.closeThisTab}</p>
    </div>
  )
})
